/* NUVEXILO: mobile sticky Buy Now, native variant sync, direct checkout. */
(function () {
  function init() {
    var bar = document.querySelector('body.template-product .sticky-cart-wrapper');
    if (!bar) return;
    var stickyForm = bar.querySelector('product-sticky-cart product-form form');
    var button = stickyForm && stickyForm.querySelector('button[type="submit"]');
    var nativeForm = document.querySelector('body.template-product .product__info-wrapper product-form form');
    var nativeButton = nativeForm && nativeForm.querySelector('.product-form__submit');
    if (!stickyForm || !button || !nativeButton) return;
    var mobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
    var syncLabel = function () {
      if (button.disabled || button.hasAttribute('data-pre-order') || button.dataset.nxLoading === 'true') return;
      if (button.textContent.trim() !== 'Buy now') button.textContent = 'Buy now';
      button.setAttribute('aria-label', 'Buy now');
    };
    syncLabel();
    new MutationObserver(syncLabel).observe(button, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled']});
    var updateVisibility = function () {
      var passedButton = window.scrollY > 120 && nativeButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('nuvexilo-visible', mobile() && passedButton);
    };
    window.addEventListener('scroll', updateVisibility, {passive:true});
    window.addEventListener('resize', updateVisibility, {passive:true});
    updateVisibility();
    document.addEventListener('submit', async function (event) {
      if (event.target !== stickyForm || !mobile()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.disabled || button.dataset.nxLoading === 'true') return;
      var idInput = stickyForm.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      var data = new FormData(stickyForm);
      data.set('id', idInput.value);
      var quantity = nativeForm && nativeForm.querySelector('input[name="quantity"]');
      if (quantity && !data.has('quantity')) data.set('quantity', quantity.value || '1');
      button.dataset.nxLoading = 'true';
      button.disabled = true;
      button.textContent = 'Opening checkout…';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (!root.endsWith('/')) root += '/';
      var errorBox = bar.querySelector('.nuvexilo-sticky-error');
      if (!errorBox) {
        errorBox = document.createElement('p');
        errorBox.className = 'nuvexilo-sticky-error';
        errorBox.setAttribute('role', 'alert');
        bar.querySelector('.sticky-cart').appendChild(errorBox);
      }
      errorBox.textContent = '';
      try {
        var response = await fetch(root + 'cart/add.js', {
          method:'POST',
          headers:{'Accept':'application/json'},
          body:data,
          credentials:'same-origin'
        });
        var result = await response.json().catch(function(){return {};});
        if (!response.ok || result.status) throw new Error(result.description || 'Could not add the item. Please try again.');
        window.location.assign(root + 'checkout');
      } catch (error) {
        errorBox.textContent = error.message || 'Could not open checkout. Please try again.';
        button.disabled = false;
        button.dataset.nxLoading = 'false';
        syncLabel();
      }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();